import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import WhatsAppCTA from '../components/WhatsAppCTA';

const MaintenanceDetail = () => {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Maintenance Detail €80 Kerry | Regular Car Care | Kingdom Auto Detailing</title>
        <meta name="description" content="Maintenance detail from €80 in Kerry. Keep your car pristine with 4-8 weekly maintenance. 20% off larger packages. Book your maintenance detail in Kerry today!" />
        <meta name="keywords" content="maintenance detail Kerry, regular car cleaning, car maintenance programme, cheap car valet Kerry, monthly car care Tralee, car cleaning subscription" />
        <link rel="canonical" href="https://kingdomautodetailing.ie/maintenance-detail" />
      </Helmet>

      <section className="relative h-[400px] bg-cover bg-center" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=1200&q=80)' }}>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative h-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">MAINTENANCE DETAIL</h1>
          <Link to="/booking" className="bg-amber-500 hover:bg-amber-600 text-zinc-900 font-bold px-8 py-4 rounded-lg transition-colors text-lg">BOOK NOW</Link>
        </div>
      </section>
      <section className="py-16 px-4 bg-zinc-900">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white mb-6">SERVICE DESCRIPTION</h2>
          <p className="text-gray-300 text-lg mb-8 leading-relaxed">Maintain your vehicle's pristine condition with our Maintenance Detail service every 4 to 8 weeks following your Full Detail. A Full Detail is required before enrolling in our Maintenance Programme.</p>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-black rounded-2xl p-6">
              <h3 className="text-2xl font-bold text-amber-500 mb-4">Exterior</h3>
              <ul className="space-y-3">
                {['Pre-wash treatment', 'Wheel faces, barrels and tyres cleaned', 'Wheel arches scrubbed and flushed', 'Safe hand wash technique', 'Door shuts cleaned and flushed', 'Ceramic sealant applied', 'Soft towel dried', 'All glass cleaned', 'Tyres dressed'].map((item, idx) => <li key={idx} className="flex items-start space-x-2 text-gray-300"><Check className="text-amber-500 mt-1 flex-shrink-0" size={20} /><span>{item}</span></li>)}
              </ul>
            </div>
            <div className="bg-black rounded-2xl p-6">
              <h3 className="text-2xl font-bold text-amber-500 mb-4">Interior</h3>
              <ul className="space-y-3">
                {['Complete vacuum of interior and boot', 'All interior surfaces cleaned and dressed', 'Interior glass cleaned', 'Fresh scent applied', 'Complimentary air freshener'].map((item, idx) => <li key={idx} className="flex items-start space-x-2 text-gray-300"><Check className="text-amber-500 mt-1 flex-shrink-0" size={20} /><span>{item}</span></li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-black">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8">
            <h2 className="text-4xl font-bold text-white mb-4">Maintenance Detail Pricing</h2>
            <p className="text-6xl font-bold text-white mb-4">€80</p>
            <p className="text-blue-100 text-lg mb-6">Plus 20% discount on all larger packages</p>
            <Link to="/booking" className="inline-block bg-white hover:bg-gray-100 text-blue-600 font-bold px-8 py-4 rounded-lg transition-colors text-lg">Book Your Maintenance Detail</Link>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-zinc-900">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-12 text-center">Frequently Asked Questions</h2>
          <div className="space-y-6">
            {[{question: 'What are the benefits of a maintenance detail package?', answer: 'Our maintenance programme provides exceptional value at just €80, plus a generous 20% discount on all larger packages. This ensures your vehicle maintains its value and appearance at optimal levels throughout the year.'}, {question: 'What happens if I miss the 4-8 week schedule?', answer: 'Missing your scheduled maintenance may result in a small additional charge of €10-€25. If you consistently miss appointments for one or more months, we will require a Full Detail package before resuming the maintenance schedule.'}, {question: 'How long does the maintenance detail take?', answer: 'The maintenance detail typically takes 2-3 hours, with the exact duration depending on your vehicle size and condition.'}, {question: 'Is the maintenance detail a deep clean?', answer: 'No, the maintenance detail is designed as a refresh service to maintain your vehicle\'s appearance between deep cleaning sessions. It keeps your car looking fresh after you\'ve had your initial Full Detail package.'}].map((faq, idx) => <div key={idx} className="bg-black rounded-2xl p-6"><h3 className="text-xl font-bold text-amber-500 mb-3">{faq.question}</h3><p className="text-gray-300 leading-relaxed">{faq.answer}</p></div>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-black">
        <div className="max-w-4xl mx-auto">
          <div className="bg-zinc-900 rounded-2xl p-8 text-center">
            <h2 className="text-2xl font-bold text-white mb-4">CANCELLATION POLICY</h2>
            <p className="text-gray-300 text-lg">To cancel or reschedule, please contact us 1-2 days in advance to avoid forfeiting your €25 deposit fee</p>
          </div>
        </div>
      </section>

      {/* WhatsApp CTA */}
      <WhatsAppCTA />
    </div>
  );
};

export default MaintenanceDetail;